import React from 'react';
import classNames from 'classnames';
import Answer from './Answer';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const Answers = ({ answers, leadText, incScratcherPos, selectChoice, scratcherPosition,
      questionNumber, numberOfQuestions, userId, sessionId, questionId }) =>  {

  const answersClass = classNames({
    'wreath__card-questions': true,
    'scene--hidden': scratcherPosition !== questionNumber
  });

  return (
    <g className={answersClass}>
      <Answer
        key={`${questionNumber}-${scratcherPosition}`}
        answer={answers[0]}
        leadText={leadText}
        selectChoice={selectChoice}
        incScratcherPos={incScratcherPos}
        scratcherPosition={scratcherPosition}
        numberOfQuestions={numberOfQuestions}
        userId={userId}
        sessionId={sessionId}
        questionId={questionId}
        d='M563.6,353.9h-305c-6.6,0-12-5.4-12-12v-50.8c0-6.6,5.4-12,12-12h305c6.6,0,12,5.4,12,12v50.8C575.6,348.5,570.2,353.9,563.6,353.9z'
        y='325.503'
      />
      <text className="wreath__button-or" textAnchor="middle" x="412.85" y="420.503">or</text>
      <Answer
        answer={answers[1]}
        leadText={leadText}
        selectChoice={selectChoice}
        incScratcherPos={incScratcherPos}
        scratcherPosition={scratcherPosition}
        numberOfQuestions={numberOfQuestions}
        userId={userId}
        sessionId={sessionId}
        questionId={questionId}
        d='M563.6,541h-305c-6.6,0-12-5.4-12-12v-50.8c0-6.6,5.4-12,12-12h305c6.6,0,12,5.4,12,12V529C575.6,535.6,570.2,541,563.6,541z'
        y='510.503'
      />
    </g>
  );
}

export default Answers;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Questions/Answers.js
 **/